import { EditorState, Modifier, SelectionState } from "draft-js";
import { TICKER_TRIGGER_REGEX } from "./tickerSchema";

export const insertMentionToEditor = (editorState: EditorState, mention: string, _name?: string): EditorState => {
  const ticker = mention;
  const content = editorState.getCurrentContent();
  const selection = editorState.getSelection();
  const block = content.getBlockForKey(selection.getStartKey());
  const blockText = block.getText();
  const cursorPos = selection.getStartOffset();
  const textBefore = blockText.slice(0, cursorPos);
  const match = textBefore.match(TICKER_TRIGGER_REGEX);

  if (!match) return editorState;
  const matchedText = match[0];
  const start = cursorPos - matchedText.length;

  const newSelection = selection.merge({
    anchorOffset: start,
    focusOffset: cursorPos,
  }) as SelectionState;

  const newContent = Modifier.replaceText(content, newSelection, `$${ticker} `);
  const withMention = EditorState.push(editorState, newContent, "insert-characters");

  const mentionLength = `$${ticker} `.length;
  const updatedSelection = SelectionState.createEmpty(selection.getStartKey()).merge({
    anchorOffset: start + mentionLength,
    focusOffset: start + mentionLength,
  });

  return EditorState.forceSelection(withMention, updatedSelection as SelectionState);
};
